/*global define*/

define([
    'jquery',
    'underscore',
    '../Configuration',
    'backbone',
    'bootstrap'
], function ($, _, Configuration, Backbone, bootstrap) {
    'use strict';
    var draggable = require('jquery-ui/ui/widgets/draggable');
    var droppable = require('jquery-ui/ui/widgets/droppable');

    var VesselView = Backbone.View.extend({
        contextMenuOpen: false,
        tagName: 'div',
        events: {
        },
        render: function(){
            this.unbind();
            this.$el.html(this.template({
                name: this.model.attributes.name,
                cid: this.model.cid,
                color: this.model.attributes.color,
                solidColor: this.model.attributes.solidColor,
                volume: this.model.attributes.volume,
                solidVolume: this.model.attributes.solidVolume,
                pour: this.model.attributes.pour,
                accept: this.model.attributes.accept,
                offset: this.model.attributes.vessel.offset,
                temperature: this.model.attributes.temperature,
                pH: this.model.attributes.pH,
                description: this.model.attributes.description,
                volumeString: this.model.attributes.volumeString,
                detailView: this.model.attributes.detailView,
                showVesselStats: Configuration.showVesselStats
            }));
            var winWidth =  $("#vlab").width();
            var scaleFactor = 1;
            if(winWidth < 768 ){
                scaleFactor = .5;
            }else if( winWidth >= 768 && winWidth <= 991){
                scaleFactor = .75;
            }else if( winWidth >= 992 && winWidth <= 1199){
                scaleFactor = 7/8;
            }
            scaleFactor *= Configuration.userScaleFactor;
            var svg = this.$el.find("svg");
            var width = svg.attr("width");
            svg.attr("width", width * scaleFactor);
            var height = svg.attr("height");
            svg.attr("height", height * scaleFactor);
            this.$el.width("auto");
            this.$el.height("auto");
/*
            var path = this.$el.find("path");
            path.css("stroke-width", 1);
*/
            this.setDragAndDrop();
            var cid = this.model.cid;
            if (this.model.get("hasTool") || this.model.get("pour")) {
                var info = $(".vesselInfo", "#" + cid);
                info.remove();
                info.prependTo("#" + cid);
            }
            this.$el.bind("contextmenu", function(event) {
                event.preventDefault();
                event.stopImmediatePropagation();
                /*$(".removeSolid").attr("id", cid);
                $(".removeLiquid").attr("id", cid);
                $(".duplicateVessel").attr("id", cid);
                $(".thermalProperties").attr("id", cid);
                $(".renameVessel").attr("id", cid);
                $(".removeVessel").attr("id", cid);*/
                $(".workbenchContextMenu").css("display", "none");
                if (this.model.get("vessel").hasDetailView) {
                    $(".detailViewGroup").css("display", "block");
                    var checkmark = $(".detailView").find(".glyphicon");
                    if (this.model.get("detailView")) {
                        checkmark.css("display","inline-block");
                    }
                    else {
                        checkmark.css("display","none");
                    }
                }
                else $(".detailViewGroup").css("display", "none");
                var menu = $(".vesselContextMenu");
                menu.css({
                    display: "block",
                    top: (event.pageY < $(window).height() / 2) ? event.pageY : event.pageY - menu.height(),
                    left: (event.pageX < $(window).width() / 2) ? event.pageX : event.pageX - menu.width()
                });
            }.bind(this));
            $(document).unbind("click");
            $(document).bind("click", function(event) {
                $(".contextMenu").hide();
                this.contextMenuOpen = false;
            });
        },
        initialize: function(){
            // this.template = require("ejs!" + this.model.attributes.vessel.template);
            //var temp1 = require('ejs-loader!../templates/250mLFlask.ejs');
            //var temp2 = require('ejs-loader!../templates/3LCarboy.ejs');
            var name = this.model.attributes.vessel.template;
            //console.log('name  is ' + name)
            if (name.includes('3LCarboy')) {
                 this.template = require('ejs-loader!../templates/3LCarboy.ejs');
               }
            else if (name.includes('5mLPipette')) {
                 this.template = require('ejs-loader!../templates/5mLPipette.ejs');
               }
            else if (name.includes('10mLPipette')) {
              this.template = require('ejs-loader!../templates/10mLPipette.ejs');
            }
            else if (name.includes('25mLPipette')) {
              this.template = require('ejs-loader!../templates/25mLPipette.ejs');
            }
            else if (name.includes('10mLGraduatedCylinder')) {
              this.template = require('ejs-loader!../templates/10mLGraduatedCylinder.ejs');
            }
            else if (name.includes('25mLGraduatedCylinder')) {
              this.template = require('ejs-loader!../templates/25mLGraduatedCylinder.ejs');
            }
            else if (name.includes('50mLGraduatedCylinder')) {
              this.template = require('ejs-loader!../templates/50mLGraduatedCylinder.ejs');
            }
            else if (name.includes('50mLBurette')) {
              this.template = require('ejs-loader!../templates/50mLBurette.ejs');
            }
            else if (name.includes('100mLBottle')) {
              this.template = require('ejs-loader!../templates/100mLBottle.ejs');
            }
            else if (name.includes('2500mLBottle')) {
              this.template = require('ejs-loader!../templates/2500mLBottle.ejs');
            }
            else if (name.includes('100mLVolumetricFlask')) {
              this.template = require('ejs-loader!../templates/100mLVolumetricFlask.ejs');
            }
            else if (name.includes('250mLVolumetricFlask')) {
              this.template = require('ejs-loader!../templates/250mLVolumetricFlask.ejs');
            }
            else if (name.includes('500mLVolumetricFlask')) {
              this.template = require('ejs-loader!../templates/500mLVolumetricFlask.ejs');
            }
            else if (name.includes('1000mLVolumetricFlask')) {
              this.template = require('ejs-loader!../templates/1000mLVolumetricFlask.ejs');
            }
            else if (name.includes('250mLStopperedFlask')) {
              this.template = require('ejs-loader!../templates/250mLStopperedFlask.ejs');
            }
            else if (name.includes('250mLFlask')) {
              this.template = require('ejs-loader!../templates/250mLFlask.ejs');
            }
            else if (name.includes('500mLFlask')) {
              this.template = require('ejs-loader!../templates/500mLFlask.ejs');
            }
            else if (name.includes('1000mLFlask')) {
              this.template = require('ejs-loader!../templates/1000mLFlask.ejs');
            }
            else if (name.includes('250mLBeaker')) {
              this.template = require('ejs-loader!../templates/250mLBeaker.ejs');
            }
            else if (name.includes('600mLBeaker')) {
              this.template = require('ejs-loader!../templates/600mLBeaker.ejs');
            }
            else if (name.includes('1000mLBeaker')) {
              this.template = require('ejs-loader!../templates/1000mLBeaker.ejs');
            }
            else if (name.includes('DisposablePipette')) {
              this.template = require('ejs-loader!../templates/DisposablePipette.ejs');
            }
            else if (name.includes('foamCup')) {
              this.template = require('ejs-loader!../templates/foamCup.ejs');
            }
            else if (name.includes('solidBottle')) {
              this.template = require('ejs-loader!../templates/solidBottle.ejs');
            }
            else if (name.includes('weighBoat')) {
              this.template = require('ejs-loader!../templates/weighBoat.ejs');
            }
            else if (name.includes('Vessel')) {
              this.template = require('ejs-loader!../templates/Vessel.ejs');
            }
            this.$el.attr('id', this.model.cid);
            this.$el.addClass("vessel");
            _.bindAll(this, "render");
            this.model.bind('change', this.render);
        },
        setDragAndDrop: function(){
            this.$el.draggable({
                opacity: 0.6,
                scroll: false,
                stack: ".flask",
                scope: "workbench",
                containment: "parent"
            });
            this.$el.droppable({
                accept: "div",
                scope: "workbench",
                hoverClass: "drag-hover",
                tolerance: "pointer"
            });
            this.$el.css("position", "absolute");
        },
    });

    return VesselView;
});
